





















































import { Meta } from '@/store/meta'
import { Server } from '@/store/server'
import {Component, Vue, Watch} from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component
export default class LoginForm extends Vue {
    email = ''
    password = ''

    hasAuthError = false

    get meta() {
        return getModule(Meta)
    }

    emailIsValid = false
    passwordIsValid = false

    @Watch("email")
    onEmailChanged(newText: string, oldText: string) {
        const ref = this.$refs.email
        if (!ref) return true
        this.emailIsValid = (ref as any).checkHtml5Validity()
    }

    @Watch("password")
    onPasswordChanged(newText: string, oldText: string) {
        const ref = this.$refs.password
        if (!ref) return true
        this.passwordIsValid = (ref as any).checkHtml5Validity()
    }

    get canPost() {
        return this.emailIsValid && this.passwordIsValid
    }

    async doLogin() {
        if (!this.canPost) {
            return
        }

        this.meta.updateLoading(true)
        
        try {
            await getModule(Server).businessUserAuthentication({
                email: this.email,
                password: this.password
            });
            this.$router.push("/")
        } catch (error) {
            this.hasAuthError = true
        } finally {
            this.meta.updateLoading(false)
        }
    }
}
